import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';
import {Easing, lerp} from '../utils/lerp.js';
import {WLUtils} from '../utils/WLUtils.js';

export class CurtainsController extends Component {
    static TypeName = 'curtains-controller';

    @property.object({required: true})
    mainCurtain!: Object3D;

    @property.float(0.1)
    distance = 0.1;

    @property.float(1)
    speed = 1;

    get curtainsClosed() {
        return !this._curtainOpen;
    }

    private _curtainOpen = false;
    private _moving = false;
    private _curtainPosition = vec3.create();
    private _t = 0;

    init(): void {
        WLUtils.setActive(this.object, false);
    }

    start(): void {
        this.mainCurtain.getPositionWorld(this._curtainPosition);
        //setTimeout(() => {
        this.open();
        //}, 4000);
    }

    update(dt: number): void {
        if (this._moving) {
            this._t += dt * this.speed;
            let p;
            if (this._t >= 1) {
                this._t = 1;
                this._moving = false;
                this._curtainOpen = !this._curtainOpen;
                p = this._curtainOpen ? this.distance : 0;
            } else {
                p = lerp(
                    0,
                    this.distance,
                    this._curtainOpen ? 1 - this._t : this._t,
                    Easing.InOutCubic
                );
            }
            this.mainCurtain.setPositionWorld([
                this._curtainPosition[0],
                this._curtainPosition[1] + p,
                this._curtainPosition[2],
            ]);
        }
    }

    open() {
        if (this._curtainOpen || this._moving) {
            return;
        }
        this._moving = true;
        this._t = 0;
    }

    close() {
        if (!this._curtainOpen || this._moving) {
            return;
        }
        this._moving = true;
        this._t = 0;
    }
}
